import {useTranslate} from "../../../../../hooks";
import {FC, useState} from "react";
import Utils from "../../../../../utils/utils";
import {Table, Tabs, Typography} from "antd";
import {ProjectPaymentSchedule} from "../../../../../models";
import { PaymentStatus } from "utils/constants";
import {TableItemStatus} from "../../../../../componets/ui";
import i18n from "i18next";

type Props = {
	data: ProjectPaymentSchedule[];
	archive: ProjectPaymentSchedule[][];
	notes: Record<string, any>[];
}

const { t } = i18n;

export const ActiveSchedule: FC<{ data: ProjectPaymentSchedule[] }> = ({ data }) => {
	const { noPaymentScheduleText2 } = useTranslate(['noPaymentScheduleText2']);
	return (
		<>
			{data.length > 0 ? (
				<Table
					className="accountTable accountTable__paymentSchedule"
					columns={[
						{
							title: '',
							dataIndex: 'paymentNumber',
						},
						{
							title: t('paymentScheduledDateText'),
							dataIndex: 'paymentDate',
							render: (v: string) => <span className="nobr">{v}</span>
						},
						{
							title: t('principalPaymentText'),
							dataIndex: 'investmentPrincipal',
							render: (amount: number) => {
								return Utils.moneyFormat(amount);
							},
						},
						{
							title: t('interestPaymentText'),
							dataIndex: 'investmentInterest',
							render: (amount: number) => {
								return Utils.moneyFormat(amount);
							},
						},
						{
							title: t('paymentStatusText'),
							dataIndex: 'status',
							render: (status: string) => {
								return (
									<TableItemStatus
										status={status === PaymentStatus.CANCELED ? `${t('PAID')}*` : status}
										isRed={status === PaymentStatus.LATE || status === PaymentStatus.PAY_WITH_DELAY}
										isGreen={status === PaymentStatus.PAID}
										isBlue={status === PaymentStatus.CANCELED}
									/>
								);
							},
						},
					] as any}
					dataSource={data}
					pagination={false}
					scroll={{ x: 425 }}
				/>
			) : (
				<Typography.Text className="primaryItem__text" style={{ paddingBottom: '1rem', display: 'block'}}>{noPaymentScheduleText2}</Typography.Text>
			)}
		</>
	);
};



export const PaymentSchedule = ({ data, archive, notes = [] }: Props) => {
	const { paymentScheduleText, activeText, versionText, loanHasBeenRepaidEarly } = useTranslate([
		'paymentScheduleText',
		'activeText',
		'versionText',
		'loanHasBeenRepaidEarly',
	]);

	const [type, setType] = useState('active');

	const reversedArchive = Utils.reverseMatrix(archive);

	const foundCancelledItem = data.find((el) => el.status === PaymentStatus.CANCELED);
	return (
		<div className="primaryItem__block" style={{ marginBottom: 0 }}>
			<Typography.Title className="primaryItem__blockTitle" level={4}>
				{paymentScheduleText}
			</Typography.Title>

			{archive.length > 0 ? (
				<Tabs
					className="accountTabs"
					type="card"
					defaultActiveKey="active"
					activeKey={type}
					onChange={(v: string) => setType(v)}
					destroyInactiveTabPane
				>
					<Tabs.TabPane tab={activeText} key="active">
						<ActiveSchedule data={data} />
					</Tabs.TabPane>

					{reversedArchive.map((item, index) => {
						return (
							<Tabs.TabPane tab={`${versionText} ${reversedArchive.length - index}`} key={index}>
								<Table
									className="accountTable accountTable__paymentSchedule"
									columns={[
										{
											title: '',
											dataIndex: 'paymentNumber',
										},
										{
											title: t('paymentScheduledDateText'),
											dataIndex: 'paymentDate',
											render: (v: string) => <span className="nobr">{v}</span>
										},
										{
											title: t('principalPaymentText'),
											dataIndex: 'investmentPrincipal',
											render: (amount: number) => {
												return Utils.moneyFormat(amount);
											},
										},
										{
											title: t('interestPaymentText'),
											dataIndex: 'investmentInterest',
											render: (amount: number) => {
												return Utils.moneyFormat(amount);
											},
										},
										{
											title: t('paymentStatusText'),
											dataIndex: 'status',
											render: (status: string) => {
												return (
													<TableItemStatus
														status={status}
														isRed={
															status === PaymentStatus.LATE ||
															status === PaymentStatus.PAY_WITH_DELAY}

														isGreen={status === PaymentStatus.PAID}
													/>
												);
											},
										},
									] as any}
									dataSource={item}
									pagination={false}
									scroll={{ x: 670 }}
								/>
							</Tabs.TabPane>
						);
					})}
				</Tabs>
			) : (
				<ActiveSchedule data={data} />
			)}
			{foundCancelledItem && <p className="project_note">{loanHasBeenRepaidEarly}</p>}
		</div>
	);
}

export default PaymentSchedule;
